const helpCenterRouter = {
  path: "/helpCenter",
  name: "helpCenter",
  component: () => import("@/views/helpCenter/index"),
  meta: {
    title: "帮助中心",
    parentPath: "/dashboard"
  }
  // children: [
  //   {
  //     path: "/helpCenter/index",

  //     name: "帮助中心",
  //     meta: { title: "帮助中心", icon: "", parentPath: "/dashboard" }
  //   }
  // ]
};

export default helpCenterRouter;
